/**
 * @generated SignedSource<<6683207f9bd4cf540f3f2cd2b7fd5c43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Integration_MarketoInfo_Query$variables = Record<PropertyKey, never>;
export type Integration_MarketoInfo_Query$data = {
  readonly marketoInfo: {
    readonly settings: {
      readonly clientId: string | null | undefined;
      readonly clientSecret: string | null | undefined;
      readonly formsEnabled: boolean | null | undefined;
      readonly hasClientSecret: boolean | null | undefined;
      readonly marketoApiActive: boolean | null | undefined;
      readonly munchkinId: string | null | undefined;
      readonly staticListIds: ReadonlyArray<string | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Integration_MarketoInfo_Query = {
  response: Integration_MarketoInfo_Query$data;
  variables: Integration_MarketoInfo_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MarketoInfo",
    "kind": "LinkedField",
    "name": "marketoInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketoSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketoApiActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "munchkinId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasClientSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staticListIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_MarketoInfo_Query",
    "selections": (v0/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Integration_MarketoInfo_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "064b0d91a16098c68636642402508a9e",
    "id": null,
    "metadata": {},
    "name": "Integration_MarketoInfo_Query",
    "operationKind": "query",
    "text": "query Integration_MarketoInfo_Query {\n  marketoInfo {\n    settings {\n      marketoApiActive\n      munchkinId\n      clientId\n      clientSecret\n      hasClientSecret\n      formsEnabled\n      staticListIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2dc894e18cf2c87d9a320c166e1b724e";

export default node;
